export default class ParseForm {
    constructor() {
        this.setElements();
        this.init();
    }

    get originForm() {
        return $($.parseHTML($('#original-donate-form').html()));
    }

    get innerForm() {
        return $('#ProcessForm');
    }

    init() {
        this.setInnerFormData();
        this.setInputs();
        this.events();
        $('.total-box .status').text($('#frequency-list label').eq(0).text());
    }

    events() {
        $('#frequency-list').on('click', 'label', function() {
            $(this).find('input').prop('checked', true);
            $('.total-box .status').text($(this).text());
        });
    }

    setElements() {
        this.formOrigin = this.originForm;
        this.formInner = this.innerForm;
    }

    setInnerFormData() {
        this.formInner.attr('action', this.formOrigin.attr('action'));
    }

    setInputs() {
        window.test = [];
        let ids = $(['idb', 'df_id', '.donation']);
        ids.each((index, item) => {
            this.setElementAttrs(this.formInner.find('[name$="' + item + '"]'), this.formOrigin.find('[name$="' + item + '"]'));
        });

        let amounts = this.formOrigin.find('[name$="amount"]');
        amounts.each((index, item) => {
            let element = this.formInner.find('[name$="amount"]').eq(index);
            this.setElementAttrs(element, $(item), ['value']);
            element.attr('placeholder', $(item).closest('.form-input').find('.donation-level-label-container').text());
        });

        this.formOrigin.find('.frequency-buttons input').each((index, item) => {
            this.formInner.find('#frequency-list li').eq(index).find('a').html($('<label/>', {
                html: [
                    $('<input/>', {
                        type: "radio",
                        name: $(item).attr('name'),
                        id: $(item).attr('id'),
                        value: $(item).attr('value'),
                        checked: index === 0,
                    }),
                    // radio_labels[$(item).attr('id')],
                    $(item).next('label').text(),
                ]
            }));
        });
        let radio = this.formOrigin.find('[name="level_standardexpanded"]');
        if (!radio.length) {
            radio = this.formOrigin.find('[name="level_standardexpanded"]');
        }
        let first = radio.filter((k, i) => $(i).closest('.donation-level-container').css('display') !== 'none');
        $(first.get().reverse()).each((index, item) => {
            let field_id = $(item).val();
            let label_text = $(item.closest('.donation-level-container')).find('.donation-level-label-container').text();
            label_text = label_text.trim().split(' ');
            let element = $('<div/>', {
                class:"col",
                html: [
                    $('<input/>', {
                        type: "radio",
                        class: "form-control",
                        name: "level_standardexpanded",
                        id: "level_standardexpanded" + field_id,
                        value: field_id,
                        checked: true,
                        'data-amount': label_text[0],
                    }),
                    $('<label/>', {
                        for: "level_standardexpanded" + field_id,
                        html: "<span>" + label_text[0] + " <em>" + (label_text[1] ? label_text[1] : '') + "</em></span>",
                    }),
                    $('<input/>', {
                        type: "hidden",
                        name: "level_standardexpandedsubmit",
                        id: "level_standard_" + field_id + "expandedsubmit",
                        value: "true",
                    }),
                ]
            });
            this.formInner.find('#frequency-first .radio-inner').prepend(element);
        });
        let second = radio.filter((k, i) => $(i).closest('.donation-level-container').css('display') === 'none');
        $(second.get().reverse()).each((index, item) => {
            let field_id = $(item).val();
            let label_text = $(item.closest('.donation-level-container')).find('.donation-level-label-container').text();
            label_text = label_text.trim().split(' ');
            let element = $('<div/>', {
                class:"col",
                html: [
                    $('<input/>', {
                        type: "radio",
                        class: "form-control",
                        name: "level_standardexpanded",
                        id: "level_standardexpanded" + field_id,
                        value: field_id,
                        checked: true,
                        'data-amount': label_text[0],
                    }),
                    $('<label/>', {
                        for: "level_standardexpanded" + field_id,
                        html: "<span>" + label_text[0] + " <em>" + (label_text[1] ? label_text[1] : '') + "</em></span>",
                    }),
                    $('<input/>', {
                        type: "hidden",
                        name: "level_standardexpandedsubmit",
                        id: "level_standard_" + field_id + "expandedsubmit",
                        value: "true",
                    }),
                ]
            });
            this.formInner.find('#frequency-second .radio-inner').prepend(element);
        });
        let amount = this.formInner.find('#monthly').data('other');
        if(amount) {
            this.formInner.find('#monthly .radio-inner .col:last-child  input[type="radio"]').attr('checked', true).trigger('click');
        }

        let inputHidden = this.formOrigin.find('.donation-levels input[type="hidden"]');
        inputHidden.each((index, item) => {
            let element = this.formInner.find('[name="' + $(item).attr('name') + '"]').eq(index);
            this.setElementAttrs(element, $(item));
        });
    }

    setElementAttrs(element, origin, prevent) {
        prevent = prevent || [];
        let attrs = {
            id: origin.attr('id'),
            name: origin.attr('name'),
        };
        if(!prevent.includes('value')) {
            attrs.value = origin.attr('value');
        }
        element.attr(attrs);
    }
}
